import chatDbCache from '@/idxdb/chat_db_cache'
import { processAccountList, processAccountFriendList } from '@/utils/chat_data_utils'
import { getUserPlatMagMenu } from "@/utils/userSetting";
import { getChatModel, setChatModel } from "@/utils/chatmodel"
import { CHAT_MDOEL } from '@/constants/common-const'

/**
 * 计算平台未读消息数量
 * @param {*} _state 
 * @param {*} allPlatAccountList 
 * @param {*} platType 
 */
const calNewMsgCount = async (_state, platType, accountList) => {
    let msgCount = 0;
    if (accountList && accountList.length > 0) {
        let arr = accountList.map(item => item.new_msg_count || 0)
        for (let c of arr) {
            msgCount += c
        }
    }
    //增加平台需修改
    if (platType == '1') {
        _state.douyinNewMsgCount = msgCount
    } else if (platType == '2') {
        _state.xiaoHsMsgCount = msgCount
    } else if (platType == '3') {
        _state.webH5NewMsgCount = msgCount
    } else if (platType == '4') {
        _state.weixinMsgCount = msgCount
    } else if (platType == '5') {
        _state.kuaishouMsgCount = msgCount
    } else if (platType == '10') {
        _state.laikeimMsgCount = msgCount
    }
}

const state = {
    //对话模式，控制台模式/平台模式
    chat_model: getChatModel(),

    // ---------- 控制台对话模式 ----------------
    //控制台模式账号列表
    ctrl_account_list: [],
    //控制台模式好友列表（数据量可能会很大）
    ctrl_friend_list: [],
    ctrl_friend_list_loading: false,
    //只是用于去重没实际业务意义
    ctrl_exists_friend_ids: new Set(),
    // ---------- END 控制台对话模式 ----------------

    //当前登录用户ID
    chat_user_id: chatDbCache.getChattingUserId(),
    //当前对话平台ID---不存db--
    chat_plat_id: chatDbCache.getUserChatPlat(),

    //用户系统配置
    user_config: {},
    //用户账号列表
    user_accounts: [],
    //用户当前选中的对话账号--
    user_account_select: {},
    //当前选中账号的好友列表
    user_account_friends: [],
    //当前选中好友，---不存db--
    user_account_select_friend: {},
    //当前选中账号好友数量 ---不存db--
    user_account_friend_count: 0,

    // ------------------------- 以下都不存DB --------------------
    //账号好友数量{}
    accountFriendCount: {},
    //系统配置是否初始化
    sysCfgInfoInited: chatDbCache.getSyCfgInfoInited(),
    //当前正在获取消息的好友ID--------
    fetchingChatLogFriendId: 0,
    // --------------------- 平台未读消息数----------
    //抖音未读消息
    douyinNewMsgCount: 0,
    //小红书未读消息
    xiaoHsMsgCount: 0,
    //webh5 未读消息
    webH5NewMsgCount: 0,
    //快手未读消息数
    kuaishouMsgCount: 0,
    //微信客服未读消息数
    weixinMsgCount: 0,
    //来客IM未读消息数
    laikeimMsgCount: 0,
    // ---------------- 隐藏的账号ID --------------
    hidAccountIds: [],
    // ---------------- 静音的账号ID --------------
    muteAccountIds: []
}

const mutations = {
    //设置控制台好友加载状态
    setctrlFriendListLoading(state, data) {
        state.ctrl_friend_list_loading = data || false
    },
    /**
     * 切换对话模式
     * @param {} state 
     */
    toggleChatModel(state) {
        let _chat_mdel = state.chat_model
        if (_chat_mdel == CHAT_MDOEL.PLAT_FORM.value) {
            state.chat_model = CHAT_MDOEL.CONTROL.value
            setChatModel(CHAT_MDOEL.CONTROL.value)
        } else {
            state.chat_model = CHAT_MDOEL.PLAT_FORM.value
            setChatModel(CHAT_MDOEL.PLAT_FORM.value)
        }
    },
    /**
     * 切换对话模式
     * @param {} state 
     */
    changehatModel(state, data) {
        state.chat_model = data
        setChatModel(data)
    },
    /**
     * 添加静音账号ID
     * @param {} state 
     * @param {*} data 
     */
    addMuteAccountId(state, data) {
        let { platId, id } = data
        //添加静音账号ID
        chatDbCache.addUserMuteAccount(platId, id)
        let muteAccountIds = chatDbCache.getUserMuteAccount(platId)
        // let muteAccountIds = chatDbCache.getUserMuteAccount(platId)
        state.muteAccountIds = muteAccountIds
    },
    /**
   * 删除静音账号ID
   * @param {} state 
   * @param {*} data 
   */
    delteMuteAccountId(state, data) {
        let { platId, id } = data
        //添加静音账号ID
        chatDbCache.deleteUserMuteAccount(platId, id)
        let muteAccountIds = chatDbCache.getUserMuteAccount(platId)
        // let muteAccountIds = chatDbCache.getUserMuteAccount(platId)
        state.muteAccountIds = muteAccountIds
    },
    /**
     * 添加隐藏账号ID
     * @param {} state 
     * @param {*} data 
     */
    addHideAccountId(state, data) {
        let { platId, id } = data
        chatDbCache.addUserHideAccount(platId, id)
        let hideAccountIds = chatDbCache.getUserHideAccount(platId)
        state.hidAccountIds = hideAccountIds
    },
    /**
       * 删除隐藏账号ID
       * @param {} state 
       * @param {*} data 
       */
    delteHideAccountId(state, data) {
        let { platId, id } = data
        chatDbCache.deleteUserHideAccount(platId, id)
        let hideAccountIds = chatDbCache.getUserHideAccount(platId)
        state.hidAccountIds = hideAccountIds
    },
    /**
  *  设置当前对话用户ID
  * @param {*} state 
  */
    setChatUserId(state, userId) {
        state.chat_user_id = userId
    },
    /**
  *  设置当前对话平台
  * @param {*} state 
  */
    setChatPlatTypeId(state, plattypeId) {
        let platChange = state.chat_plat_id == plattypeId ? false : true
        state.chat_plat_id = plattypeId

        //清空选择账号和好友
        state.user_accounts = []
        state.user_account_select = {}
        state.user_account_friends = []
        state.user_account_select_friend = {}
        state.hidAccountIds = []

        //读取缓存中的平台账号信息
        if (platChange) {
            state.user_account_friends = []

            chatDbCache.getUserAccounts(plattypeId).then(res => {
                state.user_accounts = res || []
                //== 清除不存在的账号ID ==
                //获取隐藏的账号ID(localstorage) 
                let hideAccountIds = chatDbCache.getUserHideAccount(plattypeId)
                let _accountIds = state.user_accounts.map(item => item.id) || []
                state.hidAccountIds = hideAccountIds.filter(id => _accountIds.includes(id))

                //获取静音的账号ID(localstorage) 
                let muteAccountIds = chatDbCache.getUserMuteAccount(plattypeId)
                // let _accountIds2 = state.user_accounts.map(item => item.id) || []
                state.muteAccountIds = muteAccountIds
            })
            //获取选中账号
            chatDbCache.getUserAccountSelect(plattypeId).then(res => {
                state.user_account_select = res || []
            })
        }
    },
    /**
     *  用户系统配置信息
     * @param {*} state 
     */
    setSysCfgInfo(state, data) {
        state.sysCfgInfoInited = true
        state.user_config = data || {}
    },
    /**
     * 设置初始值或者全部覆盖
     * @param {*} state 
     * @param {*} accountList 
     */
    setUserAccountsAll(state, accountList) {
        state.user_accounts = accountList || []
    },
    /**
     * 设置用户对话账号列表信息
     * @param {*} state 
     * @param {*} data 
     */
    setUserAccounts(state, accountListParam) {
        let {
            accountListResp,
            callback
        } = accountListParam
        //动作类型 1全部，2新增，3更新，4删除，默认1
        let type = accountListResp.type
        if (!type) {
            return
        }
        //找到平台的聊天账号列表
        let plat_type = accountListResp.data.plat_type
        if (!plat_type) {
            return
        }

        //腾讯咨询页（plat_type = 6 聊天端也归类为plat_type为3）
        if (plat_type === 6) {
            plat_type = 3
        }

         //百度咨询页（plat_type = 2 聊天端也归类为plat_type为3）
        if (plat_type === 7) {
            plat_type = 3
        }

        //微信小店平台（plat_type = 6 聊天端也归类为plat_type为4）
         if (plat_type === 9) {
            plat_type = 4
        }

        let dataList = accountListResp.data.accountlist
        if (!dataList) {
            dataList = []
        }
        if (!state.chat_plat_id) {
            state.chat_plat_id = plat_type
        }
        //如果响应数据是当前选中的平台账号数据
        if (plat_type == state.chat_plat_id) {
            let oldData = state.user_accounts
            //如果sub_t 不等于2_5 的时候调用 cmd:5 标记好友消息已读的时候会返回账号信息，不需要重新查询好友信息
            let sub_t = accountListResp.sub_t
            processAccountList(type, oldData, dataList).then(res => {
                chatDbCache.setUserAccounts(plat_type, res)
                calNewMsgCount(state, plat_type, res)
            })
            // ======如果当前平台有选中账号===========
            if (callback && typeof callback === 'function') {
                // 选中的用户对话账号
                chatDbCache.getUserAccountSelect(plat_type).then(res => {
                    if (res.id) {
                        //如果sub_t 不等于2_5 的时候调用 cmd:5 标记好友消息已读的时候会返回账号信息，不需要重新查询好友信息
                        if ("2_5" != sub_t) {
                            callback(res)
                        }
                        // commit('setUserAccountSelect', res)
                    } else {
                        if (dataList.length > 0) {
                            // 如果当前平台没有选中账号,选中第一个
                            //如果sub_t 不等于2_5 的时候调用 cmd:5 标记好友消息已读的时候会返回账号信息，不需要重新查询好友信息
                            if ("2_5" != sub_t) {
                                callback(dataList[0])
                            }
                        }

                    }

                })
            }

        } else {
            //获取缓存中的平台账号数据
            chatDbCache.getUserAccounts(plat_type).then(dbAccountList => {
                //处理数据合并，添加等
                return processAccountList(type, dbAccountList, dataList)
            }).then(res => {
                chatDbCache.setUserAccounts(plat_type, res)
                calNewMsgCount(state, plat_type, res)
            })
        }
    },
    /**
     * 设置选中的用户对话账号
     * @param {*} state 
     * @param {*} data 
     */
    setUserAccountSelect(state, data) {
        let accountChange = state.user_account_select?.id == data.id ? false : true
        state.user_account_select = data || {}

        if (accountChange) {
            let accountId = data.id
            chatDbCache.getUserAccountFriends(accountId).then(res => {
                state.user_account_friends = res || []
            })
            //获取平台记住的选中的账号
            chatDbCache.getUserAccountSelectFriend(accountId).then(res => {
                state.user_account_select_friend = res || {}
            })
        }
    },
    /**
   * 设置控制台好友列表
   * @param {*} state 
   * @param {*} data 
   */
    setCtrlUserAccountFriends(state, dataResp) {
        //变更加载状态
        state.ctrl_friend_list_loading = false
        let { data, pb } = dataResp
        if (!pb) {
            state.ctrl_exists_friend_ids.clear();
            state.ctrl_friend_list = data?.friendlist || []
            let cids = state.ctrl_friend_list.map(item => item.cid)
            for (let cid of cids) {
                state.ctrl_exists_friend_ids.add(cid)
            }

        } else if (pb == 'loadmore') {
            let stateList = state.ctrl_friend_list || []
            let resList = data?.friendlist || []

            resList = resList.filter(item => !state.ctrl_exists_friend_ids.has(item.cid))
            stateList.push(...resList)

            let cids = resList.map(item => item.cid)
            for (let cid of cids) {
                state.ctrl_exists_friend_ids.add(cid)
            }

            state.ctrl_friend_list = stateList
        }
    },
    /**
     * 接收到好友消息
     */
    receiveCtrlUserAccountFriends(state, dataResp) {
        // console.log('~~~~~~~~~~~~~~~~~~receiveCtrlUserAccountFriends', dataResp)
        let stateList = state.ctrl_friend_list || []
        let { data, pb, type } = dataResp
        let resList = data?.friendlist || []
        //放入消息顶端
        for (let item of resList) {
            let findIdx = stateList.findIndex(_item => _item.cid == item.cid)
            //动作类型 1全部，2新增，3更新，4删除，默认1
            if (type == 4) {
                stateList.splice(findIdx, 1)
            } else {
                if (findIdx >= 0) {
                    let olditem = Object.assign({}, stateList[findIdx], item)
                    stateList.splice(findIdx, 1)
                    stateList.splice(0, 0, olditem)
                } else {
                    stateList.splice(0, 0, item)
                }
            }
        }
        state.ctrl_friend_list = stateList
    },

    /**
     * 设置选中对话账号好友列表
     * @param {*} state 
     * @param {*} data 
     */
    setUserAccountFriendsAll(state, data) {
        state.user_account_friends = data || []
    },

    setUserAccountFriends(state, accountFriendResp) {
        //只更新当前账号的好友账号接管标识（子命令）
        let sub_t = accountFriendResp.sub_t
        if (sub_t === '3_1') {
            let friendlist = accountFriendResp.data.friendlist
            if (!friendlist) {
                friendlist = []
            }
            if (friendlist?.length > 0) {
                let updateFriend = friendlist[0]
                if (updateFriend.cid === state.user_account_select_friend?.cid) {
                    //更新好友的AI接管标识
                    state.user_account_select_friend.is_artificial = updateFriend.is_artificial
                }
            }
        } else {
            let type = accountFriendResp.type
            if (!type) {
                return
            }

            //账号ID
            let accountId = accountFriendResp.data.aid
            if (!accountId) {
                return
            }

            let friendlist = accountFriendResp.data.friendlist
            if (!friendlist) {
                friendlist = []
            }
            //当前对话账号
            let chatAccount = state.user_account_select || {}
            //当前选中的账号是此次返回数据的账号的好友信息
            if (chatAccount.id == accountId) {
                let accountFriends = state.user_account_friends

                //存入DB
                processAccountFriendList(type, accountFriends, friendlist).then(res => {
                    //获取平台记住的选中的账号
                    chatDbCache.getUserAccountSelectFriend(accountId).then(_res => {
                        if (state.user_account_friends?.length > 0) {
                            //未选中，通知选中一个好友id
                            if (!_res?.cid) {
                                //选中第一个
                                state.user_account_select_friend = state.user_account_friends[0]
                                chatDbCache.setUserAccountSelectFriend(accountId, state.user_account_friends[0])
                            } else {
                                state.user_account_select_friend = _res
                                chatDbCache.setUserAccountSelectFriend(accountId, _res)
                            }
                        }

                    })
                    chatDbCache.setUserAccountFriends(accountId, res)
                })

            } else {
                //获取缓存中的账号好友数据
                chatDbCache.getUserAccountFriends(accountId).then(dbAccountFriends => {
                    //处理数据合并，添加等
                    return processAccountFriendList(type, dbAccountFriends, friendlist)
                }).then(res => {
                    chatDbCache.setUserAccountFriends(accountId, res)
                })
            }
        }
    },
    //账号选中好友
    userAccountFriendSelect(state, friendItem) {
        if (!friendItem?.cid) {
            return
        }
        state.user_account_select_friend = friendItem || {}
        //获取平台记住的选中的账号
        let accountId = state.user_account_select?.id
        if (!accountId) {
            return
        }
        chatDbCache.setUserAccountSelectFriend(accountId, friendItem)
    },
    //正在加载聊天记录好友ID
    setFetchingChatLogFriendId(state, id) {
        state.fetchingChatLogFriendId = id
    },
    //设置账号好友数量
    setAccountFriendCount(state, data) {
        let { aid, friend_num } = data || {}
        if (aid && friend_num >= 0) {
            state.accountFriendCount[aid] = friend_num
        }
    }

}

const actions = {
    //添加静音账号ID
    doAddMuteAccountId({ commit }, data) {
        let { platId, id } = data
        if (!platId || !id) {
            return
        }
        commit('addMuteAccountId', data)
    },
    //删除静音账号ID
    doDeleteMuteAccountId({ commit }, data) {
        let { platId, id } = data
        if (!platId || !id) {
            return
        }
        commit('delteMuteAccountId', data)
    },

    //添加隐藏账号ID
    doAddHideAccountId({ commit }, data) {
        let { platId, id } = data
        if (!platId || !id) {
            return
        }
        commit('addHideAccountId', data)
    },
    //删除隐藏账号ID
    doDeleteHideAccountId({ commit }, data) {
        let { platId, id } = data
        if (!platId || !id) {
            return
        }
        commit('delteHideAccountId', data)
    },
    /**
     * 初始化系统数据信息
     * @param {*} _userId 登录用户ID
     * @param {*} selectPlat 选中的平台账号
     */
    doInitSystemData({ commit }, _userId) {
        let userId = _userId
        if (!userId) {
            userId = chatDbCache.getChattingUserId()
        } else {
            chatDbCache.setChattingUserId(userId)
        }
        commit('setChatUserId', userId)



        //查询是否有记住用户上次选中的平台ID
        let plattypeId = chatDbCache.getUserChatPlat()
        if (!plattypeId) {
            //系统默认的平台
            let platTypeMenus = getUserPlatMagMenu()
            plattypeId = platTypeMenus[0].value
        } else {
            chatDbCache.setUserChatPlat(plattypeId)
        }
        commit('setChatPlatTypeId', plattypeId)



        //获取系统配置信息
        chatDbCache.getSyCfgInfo().then(res => {
            commit('setSysCfgInfo', res)
        })
        //用户指定平台的账号列表
        chatDbCache.getUserAccounts(plattypeId).then(res => {
            commit('setUserAccountsAll', res)
        })
        //选中的用户对话账号
        // chatDbCache.getUserAccountSelect(plattypeId).then(res=>{
        //     commit('setUserAccountSelect',res)
        // })
        //设置选中对话账号好友列表
        // chatDbCache.getUserAccountFriends(plattypeId).then(res=>{
        //     commit('setUserAccountFriends',res)
        // })
    },
    doSetChatPlat({ commit }, platId) {
        commit('setChatPlatTypeId', platId)
        chatDbCache.setUserChatPlat(platId)
    },
    doSetUserId({ commit }, userId) {
        commit('setChatUserId', userId)
        chatDbCache.setChattingUserId(userId)
    },
    /**
     * 设置配置信息
     * @param {} param0 
     * @param {*} data 
     */
    doSetSysCfg({ commit }, data) {
        commit('setSysCfgInfo', data)
        chatDbCache.setSyCfgInfo(data)
    },

    /**
     * 设置选中的账号
     */
    doSetUserAccountSelect({ commit, state }, accountInfo) {
        commit('setUserAccountSelect', accountInfo)
        chatDbCache.setUserAccountSelect(state.chat_plat_id, accountInfo)
    },
    /**
     * 设置选中的账号->好友
     */
    doUserAccountFriendSelect({ commit, state }, friendItem) {
        commit('userAccountFriendSelect', friendItem)
    },

}
const getters = {
    getSysConfig(state) {
        return state.user_config || {}
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
